const LoadReactiveSearch = {
  reactiveSearchLoaded: false,

  setEvents: function () {
    const { addScript } = LoadReactiveSearch;
    const searchButton = document.querySelector('[data-action="show-form-reactive-search"]');

    if (!searchButton) return;

    //A busca abre pelo click no .search-opener, tanto no mobile quanto no desktop
    searchButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        //O clique original abre o script; o listener real (que abre o dropdown)
        //só existe depois que o script carrega, então reaplica o clique no callback
        addScript(() => searchButton.click());
      },
      { once: true }
    );
  },

  addScript: function (onLoaded) {
    if (!LoadReactiveSearch.reactiveSearchLoaded) {
      const scriptEl = document.createElement('script');
      scriptEl.src = window.reactiveSearchScript;

      if (onLoaded) {
        scriptEl.addEventListener('load', onLoaded, { once: true });
      }

      document.body.appendChild(scriptEl);

      LoadReactiveSearch.reactiveSearchLoaded = true;
    }
  },

  init: function () {
    const _this = this;

    _this.setEvents();
  },
};

export default LoadReactiveSearch;
